import HomePage from "../../Home"
import Cabecera from "./Cabecera"
import TabCliente from "./TabCliente"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { obtenerClienteAction, obtenerMovimientoReferencia } from "./../../../ducks/viajeCalendarioDuck"
import { useEffect, useState } from "react"
import BackDrop from "../../../global/BackDrop"

const VClienteDetalle = () => {
    const { referencia } = useParams()
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)

    useEffect(() => {
        setLoad(true)
        dispatch(obtenerClienteAction({referencia})).then(Response => {
            setLoad(false)
            dispatch(obtenerMovimientoReferencia({referencia}))
        })
      return () => {
      }
    }, [dispatch, referencia])
    
    return (
        <HomePage>
            <Cabecera />
            <TabCliente />
            <BackDrop open={load} />
        </HomePage>
    )
}
export default VClienteDetalle